module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row d-flex align-items-center",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-7"
  }, [_c('router-link', {
    attrs: {
      "to": "/services"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/rd-images/logo.png",
      "alt": "Rychlý drát",
      "id": "logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-2 col-sm-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col item item-1"
  }, [_c('nobr', [_c('img', {
    attrs: {
      "src": "/static/free-icons/phone.svg",
      "width": "30px"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+420212244400"
    }
  }, [_vm._v("212 244 400")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-none d-sm-block item item-2"
  }, [_c('nobr', [_c('img', {
    attrs: {
      "src": "/static/free-icons/envelope.svg",
      "width": "30px"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.rychlydrat.cz/kontakt",
      "title": "",
      "target": "_blank"
    }
  }, [_vm._v("Napište nám")])])], 1)])]), _vm._v(" "), (_vm.$store.state.customerInfo) ? _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-12 item item-3 d-flex"
  }, [_c('img', {
    attrs: {
      "src": "/static/free-icons/persona.svg",
      "width": "30px"
    }
  }), _vm._v(" "), _c('span', [_c('div', [_vm._v(_vm._s(_vm.human_readable_name(_vm.$store.state.customerInfo)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.human_readable_address(_vm.$store.state.customerInfo)))]), _vm._v(" "), _c('div', [_c('abbr', {
    attrs: {
      "title": "variabilní symbol pro platby"
    }
  }, [_vm._v("VS")]), _vm._v(" " + _vm._s(_vm.$store.state.customerInfo.id))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/logout",
      "title": ""
    }
  }, [_vm._v("odhlásit")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa5d21de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 314
// module chunks = 1 2